import { Stack } from '@mui/material';

import { classNames } from 'shared/lib/utils/classNames';

import { Text } from '../Text';
import cls from './Loader.module.scss';

interface LoaderProps {
  className?: string;
  children?: React.ReactNode | string;
  grow?: boolean;
}

export const Loader = (props: LoaderProps) => {
  const { className, children, grow } = props;

  return (
    <Stack
      gap={4}
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      flexGrow={grow ? 1 : 0}
    >
      <div className={classNames(cls.Loader, {}, [className])} />
      {typeof children === 'string' ? (
        <Text variant='body1'>{children}</Text>
      ) : (
        children
      )}
    </Stack>
  );
};
